<template>
<div class="md:items-center border-t pt-4 border-dotted">
    <div class="mb-4">
        <div class="md:flex">
            <div class="mx-auto">
                <div class="text-center mt-4">Curate Bundle Deal</div>
                <div style="max-width:520px;">
                    <div class="md:mx-8">
                        <addonform
                            image='/images/curatebundle.jpg'
                            :price='200'
                            :total='200'
                            title='Curate<br><span class="text-xs text-grey-dark">Over 30 hours of content.  Dozens of project ideas and walkthroughs. Learn to create a wealth of digital inventory including Merch, CreateSpace, Gumroad and beyond!</span><br><br>
                            <span class="text-xs text-grey-dark">Also get two free months of our Tangent Software.</span>'
                            product='curate_bundle'>
                        </addonform>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

</template>
<script>
    import addonform from './addonForm'
    export default {
        components: { addonform }
    }

</script>
